var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "fixed inset-0 z-10 bg-black bg-opacity-40 flex justify-center items-center",
    },
    [
      _c("div", { staticClass: "w-96 rounded-lg p-6 bg-white shadow-lg" }, [
        _c(
          "div",
          { staticClass: "flex justify-between items-center" },
          [
            _c("p", { staticClass: "font-bold" }, [
              _vm._v(
                _vm._s(_vm.isAll ? _vm.$t("lmsSms.all") : "") +
                  " " +
                  _vm._s(_vm.$t("lmsSms.sendSmsButton"))
              ),
            ]),
            _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mt-3" },
          [
            _c("GrmTextarea", {
              ref: "content",
              model: {
                value: _vm.content,
                callback: function ($$v) {
                  _vm.content = $$v
                },
                expression: "content",
              },
            }),
            _c(
              "GrmBtn",
              { staticClass: "w-full", on: { click: _vm.onSendSMS } },
              [_vm._v(_vm._s(_vm.$t("lmsSms.send")))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }